import { render, staticRenderFns } from "./AdminFabricsScreen.vue?vue&type=template&id=40b3f1e2&scoped=true&"
import script from "./AdminFabricsScreen.vue?vue&type=script&lang=js&"
export * from "./AdminFabricsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b3f1e2",
  null
  
)

export default component.exports